import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/workspace/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProviderClient"] */ "/workspace/src/locales/client.ts");
